import styled from 'styled-components';
import media from 'client/styles/media';
import { Container } from 'client/components/layout';

const PaddingContainer = styled(Container)`
  padding-left: 30px;
  padding-right: 30px;

  ${media.sm} {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export default PaddingContainer;
